import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';
import React from 'react';

const ButtonWidget = ({ type, onClick, label }: any) => {
  let elem;

  switch (type) {
    case 'delGroup':
    case 'delRuleGroup':
    case 'delRule':
      elem = (
        <Tooltip title={label}>
          <IconButton onClick={onClick} color="primary" aria-label={label} size="large">
            <CloseIcon />
          </IconButton>
        </Tooltip>
      );
      break;
    case 'addRule':
    case 'addGroup':
    case 'addRuleGroup':
    default:
      elem = (
        <Button color="primary" type="button" onClick={onClick}>
          {label}
        </Button>
      );
      break;
  }

  return elem;
};

export default ButtonWidget;
